/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DictionaryEntryDto, EmployeeDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class EmployeeController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags employee-controller
     * @name ApiV1EmployeesUsingGet
     * @summary employees
     * @request GET:/api/v1/employees
     * @secure
     */
    apiV1EmployeesUsingGet = (query: { showActive: boolean }, params: RequestParams = {}) =>
        this.request<EmployeeDto[], void>({
            path: `/api/v1/employees`,
            method: 'GET',
            query: query,
            secure: true,
            ...params,
        });
    /**
     * No description
     *
     * @tags employee-controller
     * @name ApiV1EmployeesViewsDictionaryUsingGet
     * @summary viewDictionary
     * @request GET:/api/v1/employees/views/dictionary
     * @secure
     */
    apiV1EmployeesViewsDictionaryUsingGet = (query: { showActive: boolean }, params: RequestParams = {}) =>
        this.request<DictionaryEntryDto[], void>({
            path: `/api/v1/employees/views/dictionary`,
            method: 'GET',
            query: query,
            secure: true,
            ...params,
        });
}
